/**
 * Tiện ích branding - Branding & Logo Utilities
 *
 * Chức năng:
 * - Lấy và cập nhật favicon/logo cơ sở từ API
 * - Cache favicon path vào localStorage
 * - Xây dựng URL cho asset branding
 */
import api from '../api';

const FALLBACK_FAVICON = '/favicon.ico';
const FAVICON_CACHE_KEY = 'cms-favicon-logo-path';

function getUploadsBase(): string {
  return String(api.defaults.baseURL || '/api').replace(/\/api\/?$/, '');
}

function buildBrandAssetUrl(logoPath: string): string {
  const path = String(logoPath || '').trim();
  if (!path) return FALLBACK_FAVICON;
  if (/^https?:\/\//i.test(path)) return path;
  return `${getUploadsBase()}${path.startsWith('/') ? path : `/${path}`}`;
}

function ensureFaviconElement(): HTMLLinkElement {
  const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (existing) return existing;
  const created = document.createElement('link');
  created.rel = 'icon';
  document.head.appendChild(created);
  return created;
}

export function applyFavicon(logoPath?: string | null): void {
  const href = logoPath ? buildBrandAssetUrl(logoPath) : FALLBACK_FAVICON;
  ensureFaviconElement().href = href;
}

export function saveFaviconLogoPath(logoPath?: string | null): void {
  if (!logoPath) {
    window.localStorage.removeItem(FAVICON_CACHE_KEY);
    return;
  }
  window.localStorage.setItem(FAVICON_CACHE_KEY, logoPath);
}

export function loadCachedFaviconLogoPath(): string | null {
  return window.localStorage.getItem(FAVICON_CACHE_KEY);
}
